






























































































import Vue from 'vue'
import FormField from './AppFormField.vue'
import RelationshipField from './RelationshipField.vue'

export default Vue.extend({
  name: "AppForm",
  components: { FormField, RelationshipField },
  props: {
    formFields: {
      type: Array as () => Array<FormField>,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    relatable: {
      type: Object,
      default: () => {
        return {}
      }
    },
    submitButtonText: {
      type: String,
      default: "Submit"
    }
  },

  data() {
    return {
      data: {},
      resetting: false
    }
  },

  computed: {
    fields():FormField[] {
      let fields = this.formFields.filter(field => field.display == "field")
      fields = fields.map(field => {
        if (field.fieldTag === 'select' && typeof field.options === 'string') {
          const optionsField = fields.find(optionField => optionField.key == field.options)
          const options = optionsField ? optionsField[field.options] || [] : []
          return Object.assign(field, {options})
        } else {
          return field
        }
      })
      return fields
    },
    meta():FormField[] {
      return this.formFields.filter(field => field.display == "meta")
    },
    relationships():FormField[] {
      return this.formFields.filter(field => field.display == "relationship")
    }
  },

  methods: {
    dataChange(key, value) {
      this.$set(this.data, key, value)
    },
    initData() {
      this.$schema.sort(this.formFields, ['order', 'label']).forEach(field => {
        if (field.key && field.key !== "preview") {
          if (typeof field.value !== 'undefined') {
            this.$set(this.data, field.key, field.value)
          } else {
            this.$set(this.data, field.key, field.defaultValue)
          }
        }
      })
    },
    reset() {
      this.resetting = true
      this.initData
      this.resetting = false
    },
    submit() {
      this.$emit('submit', this.data)
    }
  },

  created() {
    this.initData()
  },

  mounted() {

  }

})
